export default __webpack_public_path__ + "static/media/kids-plus-helmets.33ae3238.jpg";